import { dispatch } from '../../store';
import { expandWidget } from './expandWidget';

export function openWidget() {
  dispatch('widget/setSdkExpandingInProgress', true);
  setTimeout(() => {
    // There is a race condition when collapse is triggered due to out-of-widget click.
    // So making sure we're re-expanding the widget after the collapse event handlers completed.
    expandWidget();
    dispatch('widget/setSdkExpandingInProgress', false);
  });
}
